"use client";

import { ReactNode } from "react";
import Badge from "~/componentsDS/Badge";
import { QuizCTA } from "~/components/features/quiz";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import GetStarted from "~/componentsDS/GetStarted";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { GET_STARTED_REDESIGN } from "~/constants/flags";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import useFlag from "~/hooks/useFlag";
import HowItWorksSection from "./HowItWorksSection";
import { hrtHiwData } from "../data/hiw-data";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";

type Props = {
    heading?: ReactNode;
    howItWorksClassName?: string;
    carouselClassName?: string;
    ctaTitle?: string;
};

const GetStartedSection = ({ heading = "Getting started is simple", howItWorksClassName, carouselClassName, ctaTitle = "Check Your Eligibility" }: Props) => {
    const isRedesign = !!useFlag(GET_STARTED_REDESIGN);

    if (isRedesign) {
        return (
            <section className="pt-8">
                <ElementorContainer>
                    <Reveal>
                        <Badge className="mb-4 font-medium">How it works</Badge>
                        <Heading as="h2" size="sm" sizes={{md: "md"}} className="text-primary500 mb-6 lg:mb-8">
                            {heading}
                        </Heading>
                    </Reveal>
                </ElementorContainer>

                <GetStarted
                    innerContainerClassName="
                      max-w-[1920px] px-6 min-[1025px]:px-12 min-[1280px]:px-16 min-[1440px]:px-20 min-[1728px]:px-[144px]
                    "
                />

                <ElementorContainer>
                    <div className="flex flex-col items-center w-full mt-6 md:mt-10">
                        <QuizCTA
                            variant="primary"
                            eventData={{
                                widget: "how_it_works",
                                event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                                meta_data: {
                                    click_text: ctaTitle,
                                },
                            }}
                            href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                            size="md"
                        >
                            <TextWithRegisteredMark text={ctaTitle} />
                        </QuizCTA>
                        <Paragraph className="text-gray400 mt-2" size="xs">Free shipping. Cancel anytime. HSA/FSA Eligible.</Paragraph>
                    </div>
                </ElementorContainer>
            </section>
        )
    }

    return (
        <HowItWorksSection
            heading={heading}
            steps={hrtHiwData}
            CTA_TITLE={ctaTitle}
            className={howItWorksClassName}
            classNameCarousel={carouselClassName}
        />
    );
};

export default GetStartedSection;
